import React from 'react';

import { VideoStudioDialogMount } from '@/components/create/v2/sections/video-studio/VideoStudioDialogMount';
import type { InspectorBreadcrumbItem } from '@/components/ui/inspector/types';

interface VideoBodyProps {
  mediaId: string;
  jobId?: string;
  onClose: () => void;
  breadcrumbs?: InspectorBreadcrumbItem[];
  backToProject?: { id: string; name: string; onReturn: () => void };
}

/**
 * VideoBody — minimal placeholder. The production video iteration flow
 * goes through `VideoStudioCanvas` + `useVideoDialogStore` (the dedicated
 * studio surface), and Inspector "video" subjects open that store on
 * mount rather than rendering this body. v5 contract maintained here so
 * the body still looks consistent with the rest of the system if it
 * ever shows.
 */
function toMediaBreadcrumb(breadcrumbs: InspectorBreadcrumbItem[] | undefined) {
  const root = breadcrumbs?.[0];
  const leaf = breadcrumbs?.[breadcrumbs.length - 1];
  if (!root || !leaf) return undefined;
  return { rootLabel: root.label, rootHref: root.href, leafLabel: leaf.label };
}

export const VideoBody: React.FC<VideoBodyProps> = ({
  mediaId,
  jobId,
  onClose,
  breadcrumbs,
  backToProject,
}) => {
  void mediaId;
  void jobId;
  void onClose;
  void backToProject;

  return <VideoStudioDialogMount inline breadcrumb={toMediaBreadcrumb(breadcrumbs)} />;
};
